import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.609 3.83c-.765-.127-1.945-.214-2.609.283V21a1 1 0 1 1-2 0V4.029c0-2.291 3.342-2.437 4.936-2.173 1.07.178 2.175.611 3.51 1.278 1.189.593 2.39.444 3.651.302C18.113 3.32 19 3.883 19 5v7c0 .987-.818 1.66-1.684 1.949-1.893.63-4.218-.015-5.87-1.117-.335-.223-.958-.512-1.493-.538a1 1 0 1 1 .094-1.997c1.035.049 2.011.54 2.508.87 1.037.693 3.256 1.635 4.445.73V5.469c-1.54.237-3.024.164-4.446-.546-1.272-.634-2.167-.965-2.945-1.094",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_flag-DXejD1r2.js.map
